import React from "react";
import { useParams } from "react-router-dom";
import ReconsiderationCommon from "../../../../../components/common-content/reconsideration/ReconsiderationCommon";
import Loader from "../../../../../components/custom/Loader";
import CopyrightPreviewFormOne from "../../../../../components/preview_applications/copyright/CopyrightPreviewFormOne";
import CopyrightPreviewFormTwo from "../../../../../components/preview_applications/copyright/CopyrightPreviewFormTwo";
import PaymentPreview from "../../../../../components/preview_applications/payment/PaymentPreview";
import { useGetSubmittedCopyrightDetailsQuery } from "../../../../../redux/api/submittedCopyrightAgreementApiSlice";
import { useAuth } from "../../../../../utils/authorization";
import { CopyrightGenerateAttachArray } from "../../../../../utils/CopyrightGenerateAttachArray";
import { transformCopyrightData } from "../../../../../utils/transformCopyrightData";
import CommonDetails from "../../details/CommonDetails";

const ReconsiderationCopyrightDetails = () => {
  const { authUser } = useAuth();
  const { id } = useParams();
  const { data, isLoading } = useGetSubmittedCopyrightDetailsQuery(id, {
    refetchOnMountOrArgChange: true,
  });
  const details = data?.data?.profileDetail;

  const forInfo = transformCopyrightData(data);

  if (isLoading) {
    return <Loader />;
  }
  const infoTable = CopyrightGenerateAttachArray(forInfo);

  const info = {
    fileStatus: Number(data?.data?.fileStatus),
    noteNumber: data?.data?.trackReg,
    regNumber: "",
    applicantName: details?.profileDetailType?.[0]?.name,
    workTitle: details?.workTitle,
    category: details?.category?.name,
    amount: data?.data?.amount,
    challan: Number(data?.data?.st) === 3 ? "চালান" : "ট্রেজারি",
    challanNumber:
      Number(data?.data?.st) === 3
        ? data?.data?.echallanId
        : data?.data?.treasuryNo,
    treasuryDate: data?.data?.treasuryDate || new Date(),
    admin: data?.data?.admin,
    fromAdmin: data?.data?.fromAdmin,
    comments: data?.data?.comments[data?.data?.comments.length - 1] || {},

    basicStatus: Number(data?.data?.basicStatus),
    treasuryStatus: Number(data?.data?.treasuryStatus),
  };

  const formOne = (
    <div className="pt-5">
      <CopyrightPreviewFormOne data={data?.data} />
    </div>
  );
  const formTwo = (
    <div className="pt-5">
      <CopyrightPreviewFormTwo data={details} />
    </div>
  );

  const comments =
    authUser?.id === 8
      ? data?.data?.comments.find((c) => Number(c.submit) === 2)
      : data?.data?.comments.length > 0 && data?.data?.comments[0];

  const commentsValue = data?.data?.comments.find(
    (c) => Number(c.submit) === 2
  );

  const noteSheetList =
    data?.data?.comments.filter((c) => Number(c.submit) === 1) ?? [];

  const breadcrumbsTitle =
    Number(data?.data?.fileStatus) === 33
      ? "অনুমোদন পুনর্বিবেচনা"
      : Number(data?.data?.fileStatus) === 34
      ? "নথিজাত পুনর্বিবেচনা"
      : "অননুমোদন পুনর্বিবেচনা";

  const content = (
    <ReconsiderationCommon comments={commentsValue} info={info} breadcrumbsTitle={breadcrumbsTitle} />
  );

  const commentsNoteSheet = {
    noteSheetList,
    noteSheetValues: comments?.status,
  };

  return (
    <div>
      <CommonDetails
        content={content}
        commentsNoteSheet={commentsNoteSheet}
        formOne={formOne}
        formTwo={formTwo}
        payment={
          <div className="p-4 mt-5">
            <PaymentPreview data={data?.data} />
          </div>
        }
        info={info}
        infoTable={infoTable}
        breadcrumbsTitle2={"পুনর্বিবেচনার নথি"}
        breadcrumbsTitle={breadcrumbsTitle}
      />
    </div>
  );
};

export default ReconsiderationCopyrightDetails;
